import { ValueFormatterParams } from 'ag-grid-community';

export function formatEmbryoName(embryo: {
  name?: string | null;
  donorName?: string | null;
  sireName?: string | null;
}): string {
  if (embryo.name) return embryo.name;
  const donor = embryo.donorName;
  const sire = embryo.sireName;
  if (donor && sire) return `${donor} X ${sire}`;
  return donor || sire || '';
}

export function embryoNameFormatter(params: ValueFormatterParams<any, string>) {
  return formatEmbryoName(params.data ?? {});
}
